import { createClient } from 'contentful';

async function cmsData(params, wrapper = false) {
  const client = createClient({
    space: process.env.CTF_SPACE,
    accessToken: process.env.CTF_TOKEN,
    environment: process.env.CTF_ENVIRONMENT || '',
  });

  const data = await client.getEntries(params)
    .then(response => (wrapper ? response : response.items));

  return data;
}

export default cmsData;
